"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NGLService = void 0;
const types_1 = require("../models/ticket/types");
const api_1 = require("./api");
const ngl_api_1 = require("./ngl-api");
const PATH = '/web/instants/rest/games/igf';
const PATH_V2 = '/web/igs-game/games';
class NGLService {
    static async getNGLGameData(gameId, v2Game, topPrizeMultiplier) {
        if (v2Game) {
            const response = await NGLService.getNGLGameDatav2(gameId, topPrizeMultiplier);
            return response;
        }
        const response = await ngl_api_1.NGLAPI.get({ url: `${PATH}/${gameId}/init` });
        const wagers = [];
        if (response.result) {
            for (let i = 0; i < response.result.betAmountsAllowed.length; i++) {
                const topPrize = Math.max.apply(Math, response.result.prizeCategoryInfo
                    .filter((p) => p.playLevel === i + 1)
                    .map((p) => p.prizeAmount));
                wagers.push({
                    value: response.result.betAmountsAllowed[i],
                    topPrizeValue: topPrize,
                    topPrizeType: types_1.PrizeType.TOKENS
                });
            }
        }
        response.result.wagers = wagers;
        return {
            response: response.result
        };
    }
    static async getNGLGameDatav2(gameId, topPrizeMultiplier) {
        const response = await ngl_api_1.NGLAPIv2.get({ url: `${PATH_V2}/${gameId}/init` });
        const wagers = [];
        if (response) {
            for (let i = 0; i < response.betAmounts.length; i++) {
                const topPrize = topPrizeMultiplier ? response.betAmounts[i] * topPrizeMultiplier : 0;
                wagers.push({
                    value: response.betAmounts[i],
                    topPrizeValue: topPrize,
                    topPrizeType: types_1.PrizeType.TOKENS
                });
            }
        }
        response.wagers = wagers;
        return { response };
    }
    static async getPBLToken() {
        return api_1.API.get({ url: '/uaa/api/v1/account/token' });
    }
    static async setNGLToken(launchToken, v2Game) {
        const apiVersion = v2Game ? ngl_api_1.NGLAPIv2 : ngl_api_1.NGLAPI;
        return apiVersion.post({
            url: `/web/gateway/session/token`,
            body: {
                launchToken
            }
        });
    }
    static async startNGLGameSession(gameId, funMode, v2Game, clientSessionToken) {
        const url = funMode ? 'DEMO/demo' : '/main';
        const urlv2 = funMode ? 'DEMO' : '';
        const apiVersion = v2Game ? ngl_api_1.NGLAPIv2 : ngl_api_1.NGLAPI;
        return apiVersion.post({
            url: v2Game ? `${PATH_V2}/${gameId}${urlv2}` : `${PATH}/${gameId}${url}`,
            headers: v2Game && clientSessionToken
                ? {
                    session: clientSessionToken
                }
                : {},
            body: {
                methodName: 'startGameSession',
                methodParameters: v2Game ? [] : funMode ? [gameId.concat('DEMO')] : [gameId]
            }
        });
    }
    static async startNGLGame(gameId, wager, clientSessionId, clientRequestToken, funMode, v2Game, clientSessionToken) {
        const url = funMode ? 'DEMO/demo' : '/main';
        const urlv2 = funMode ? 'DEMO' : '';
        const apiVersion = v2Game ? ngl_api_1.NGLAPIv2 : ngl_api_1.NGLAPI;
        return apiVersion.post({
            url: v2Game ? `${PATH_V2}/${gameId}${urlv2}` : `${PATH}/${gameId}${url}`,
            headers: v2Game && clientSessionToken
                ? {
                    session: clientSessionToken
                }
                : {},
            body: {
                methodName: v2Game ? 'singlePlay' : 'startPlay',
                methodParameters: [wager, 1],
                clientSessionId,
                clientRequestToken
            }
        });
    }
    static async endNGLGame(gameId, clientSessionId, clientRequestToken, funMode) {
        const url = funMode ? 'DEMO/demo' : '/main';
        return ngl_api_1.NGLAPI.post({
            url: `${PATH}/${gameId}${url}`,
            body: {
                methodName: 'endPlay',
                methodParameters: [],
                clientSessionId,
                clientRequestToken
            }
        });
    }
}
exports.NGLService = NGLService;
//# sourceMappingURL=ngl-service.js.map